<div class="success-wrapper">

  <!-- Loading -->
  <div *ngIf="loading" class="text-center">
    <div class="spinner-border text-success mb-3"></div>
    <p>Confirming your payment…</p>
  </div>

  <!-- Error -->
  <div *ngIf="error" class="alert alert-danger text-center">
    {{ error }}
  </div>

  <!-- Success -->
  <ng-container *ngIf="payment$ | async as payment">
    <div class="card shadow-lg border-0 success-card">
      <div class="card-body text-center p-5">

        <!-- Animated Checkmark -->
        <div class="checkmark-wrapper mb-4">
          <svg class="checkmark" viewBox="0 0 52 52">
            <circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none" />
            <path
              class="checkmark-check"
              fill="none"
              d="M14 27l7 7 17-17"
            />
          </svg>
        </div>

        <h2 class="mb-2 fw-bold">Payment Successful</h2>
        <p class="text-muted mb-4">
          Your payment has been received and recorded.
        </p>

        <hr />

        <div class="row text-start mt-4">
          <div class="col-md-6 mb-3">
            <strong>Amount Paid</strong><br />
            ${{ payment.amount / 100 | number:'1.2-2' }}
          </div>

          <div class="col-md-6 mb-3">
            <strong>Status</strong><br />
            {{ payment.status | titlecase }}
          </div>

          <div class="col-md-6 mb-3">
            <strong>Payment Method</strong><br />
            {{ payment.paymentMethod | titlecase }}
          </div>

          <div class="col-md-6 mb-3">
            <strong>Transaction ID</strong><br />
            <small class="text-muted">{{ payment.id }}</small>
          </div>
        </div>

        <button
          class="btn btn-success btn-lg mt-4 px-5"
          (click)="goToDashboard()">
          Go to Dashboard
        </button>

      </div>
    </div>
  </ng-container>
</div>
